import {
  Dialog,
  DialogTitle,
  DialogContent,
  Stack,
  Typography,
  DialogActions,
  Button,
  TextField,
} from '@mui/material';
import {useState} from 'react';

export interface CallNoteProps {
  open: boolean;
  message: React.ReactNode | string;
  handleClose: () => void;
  handleCancel?: () => void;
  handleConfirm?: (message: string) => void;
  loading: boolean;
  projectName: string;
}

export const Confirmation = ({
  open,
  message,
  handleClose,
  handleCancel,
  handleConfirm,
  loading = false,
  projectName = '',
}: CallNoteProps) => {
  const [input, setInput] = useState<string>('');

  const handleConfirmClicked = () => {
    setInput('');
    handleClose();
    if (handleConfirm) handleConfirm(input);
  };

  const handleCancelClicked = () => {
    handleClose();
    setInput('');
    if (handleCancel) handleCancel();
  };

  return (
    <Dialog open={open} maxWidth="lg">
      <DialogTitle>
        I want to delete this Tenant
        <strong>&quot;{projectName}&quot;</strong>?
      </DialogTitle>
      <DialogContent>
        <Stack spacing={1} width="500px">
          <Typography variant="body2">{message}</Typography>
          <TextField
            id="outlined-basic"
            variant="outlined"
            color={input === projectName ? 'success' : 'warning'}
            value={input}
            size="small"
            sx={{borderRadius: '10px'}}
            onChange={event => setInput(event.target.value)}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleCancelClicked}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleConfirmClicked}
          disabled={input === projectName ? false : true}
        >
          {loading ? 'Confirming...' : 'Confirm'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
